import Service, { type Registry as Services, service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import CalendarModel from 'uplisting-frontend/models/calendar';
import type { ICalendarViewport } from 'uplisting-frontend/services/calendar/utils';
import type { ICalendarLoadOptions } from 'uplisting-frontend/services/repositories/calendar';

export const CALENDAR_DATES_PER_PAGE = 21;

export default class CalendarManagerService extends Service {
  @service('calendar/data') data!: Services['calendar/data'];
  @service('calendar/utils') utils!: Services['calendar/utils'];
  @service('calendar/interaction')
  interaction!: Services['calendar/interaction'];

  @service('repositories/calendar')
  repository!: Services['repositories/calendar'];

  @cached @tracked viewport!: ICalendarViewport;

  public async loadData(options: ICalendarLoadOptions): Promise<CalendarModel> {
    this.#createViewport(options.startDate);

    const data = await this.repository.loadData(options);

    this.data.setupFasterLookup();

    return data;
  }

  #createViewport(startDate: Date): void {
    this.viewport = this.utils.createCalendarViewport(startDate);
  }
}

declare module '@ember/service' {
  interface Registry {
    'calendar/manager': CalendarManagerService;
  }
}
